import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Contact from './pages/Contact';
import FloatingContactButtons from './components/FloatingContactButtons';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import NavbarEmergency from './components/NavbarEmergency';
import NavbarSEO from './seo/NavbarSEO';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <NavbarEmergency />
      <div className="flex flex-col min-h-screen bg-slate-50">
        
        <NavbarSEO />  

        <Navbar />
        <FloatingContactButtons />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <ScrollToTopButton />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

